/*
  Challenge 4
  Enter the code in the correct order.
 */

// Utils
var $ = require ('jquery');
var resizer = require('../lib/fullResizer');
var videoSequence = require('../lib/video-promise');
var canvastools = require('../lib/canvas');
var MemorySequence = require('../lib/memorySequence');
var countdownFactory = require("../lib/countdown");


//Video
var mainVideo = document.getElementById('mainVideo');
var replaySequence = videoSequence(mainVideo, "0:01:48:14", "0:01:50:14");

// Fail and Success views
var uioptions = {
  uiclasses: {
    number: "icon-number--4",
    gesture: "icon-gesture--tap"
  }
};
var failMaker = require('../lib/fail');
var failView = failMaker(replaySequence, uioptions);
var successFactory = require('../lib/success');
var successView = successFactory(uioptions);

var view = function () {
  // DOM
  var $wrapper = $('#appendHere');
  var template = require('../templates/challenge4.hbs');
  var $html = $(template());
  var $keypad = $html.find("#keypad");
  var memorySequence = new MemorySequence($keypad);

  var countdownCanvas = $html.find('#countdown').get(0);

  var initChallenge = function () {
    $wrapper.off();
    $wrapper.html($html);


    var countdown = countdownFactory(countdownCanvas);
    var sequence = memorySequence.newSequence(3);

    var resetView = function () {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          $wrapper.addClass('in');
          resolve();
        }, 250);
      });
    };

    var raceFactory = function () {
      return Promise.race([
          countdown.countdown(5000),
          memorySequence.listenForSequence()
        ])
        .then(function (result) {
          if (result === "challenge:fail"){
            $wrapper.html('')
              .removeClass('in');

            return failView()
                    .then(initChallenge)
                    .catch(console.log.bind(console));
          } else {
            return successView(result);
          }
        })
        .catch(console.log.bind(console));
    };

    return resetView()
              .then(function () {
                return memorySequence.hintSequence();
              })
              .then(raceFactory)
              .catch(console.log.bind(console));
  };

  return initChallenge();
};

module.exports = view;
